<template lang="pug">
  .component-backoffice-wallet-uninvoiced
    //pre {{item}}
    .inner-content
      .row
        .column
          label Client
          router-link(:to="{name:'client', params:{id:item.client.id}}") CL{{item.client.id}} {{item.client.name}} {{item.client.surname}}
        .column
          label Uninvoiced Records
          .field-value {{item.records.length}}
        .column
          label Amount
          .field-value(:class="{'warning-text':item.billable_amount < 0}")
            strong {{$priceWithcurrency(item.billable_amount)}}
        .column
          .text-right
            button.button.fa.fa-2x(:class="{'fa-arrow-up':detail, 'fa-arrow-down':!detail}", @click="detail = !detail")

      template(v-if="detail" )
        table
          thead
            tr
              th Id
              th Driver Id
              th Type & Id
              th Description (Reason)
              th.text-center Tax
              th.text-center Amount
          tbody
            tr(v-for="item in item.records")
              td {{item.id}}
              td {{item.driver_id}}
              td
                div {{item.walletable_type | walletableType}}
                div {{item.walletable_id}}
              td(style="font-family: monospace;")
                div(v-for="reason in item.reason.split('|')")
                  hr(v-if="reason.startsWith('---')", style="border-style: dotted; margin:0.5em")
                  strong(v-else-if="reason.startsWith('- ')") {{cleanString(reason,"- ")}}
                  span(v-else-if="reason.startsWith('>>')", style="display: block; text-indent: 1em;") {{cleanString(reason,">>")}}
                  span(v-else) {{reason}}
              //td(v-html="explodeReason(item.reason)")
              td.text-center
                div
                  strong {{$priceWithcurrency($priceWithVat(item.amount, item.tax).toFixed(2))}}
                div
                  small {{-item.tax*100}}%
              td.text-center
                div {{$priceWithcurrency($priceWithVat(-item.amount, -item.tax).toFixed(2))}}
                div
                  small {{$priceWithcurrency(-item.amount)}} VAT EXC
        ActionButton(:action="billWallet", confirm) Bill wallet
        //BilledRecords(:item="item")
        //pre {{item.records}}
</template>

<script type="text/babel">

import BackofficeClient from "./Client";
import InvoiceFields from "../structure/ui/entity-fields/InvoiceFields";
import BackofficeWalletRecord from "./WalletRecord";
import BilledRecords from "./BilledRecords";
import ActionButton from "../structure/ui/ActionButton";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

export default {
  name: "BackofficeWalletUninvoiced",
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      detail: false
    }
  },
  created() {
  },
  components: {
    ActionButton,
    BilledRecords,
    BackofficeWalletRecord,
    InvoiceFields,
    BackofficeClient,
  },
  methods: {
    cleanString(string, char) {
      const r = new RegExp(`${char}`, 'gi');
      return string.replace(r, "")
    },
    billWallet() {
      return KeplerBackofficeSdk.wallets.select(this.item.wallet_id).billWallet(()=>{
        this.$emit('itemUpdated')
      })
    }
  },
  filters: {
    walletableType(value) {
      return value.replace(/App\\Models\\/, '')
    }
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">
.component-backoffice-wallet-uninvoiced
  .component-billed-records
    width: 100%
</style>



// WEBPACK FOOTER //
// WalletUninvoiced.vue?68bcda6e